package com.shadowings.gero.data.lessons.chapter3

import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import com.shadowings.gero.domain.model.ExplanationContent
import com.shadowings.gero.domain.model.Faces
import com.shadowings.gero.domain.model.Characters
import com.shadowings.gero.domain.model.IExplanation
import com.shadowings.gero.domain.model.IQuizContent
import com.shadowings.gero.domain.model.TrueFalseContent
import com.shadowings.gero.presentation.component.MdCWord
import gero.composeapp.generated.resources.*

fun getFillerACapoComplementiContent(): List<IExplanation> {
    return listOf(
        ExplanationContent(
            title = Res.string.exp_title_andare_a_capo,
            content = Res.string.exp_content_in_egiziano_antico_non_c_erano_regole_rigide_,
            face = Faces.Happy
        ),
        ExplanationContent(
            title = Res.string.exp_title_andare_a_capo,
            content = Res.string.exp_content_se_lo_spazio_finiva_potevano_spezzare_una_par,
            face = Faces.Surprised,
            composable = {
                MdCWord("X1:X2-N35:N35:N35-G43-D21-G17-K1-M17-G43B-S34", rtl = false, cart = false)
            }
        ),
        ExplanationContent(
            title = Res.string.exp_title_direzione_di_lettura,
            content = Res.string.exp_content_come_sappiamo_i_geroglifici_si_leggono_nella_,
            face = Faces.Serious
        ),
        ExplanationContent(
            title = Res.string.exp_title_direzione_di_lettura,
            content = Res.string.exp_content_ma_se_una_scritta_composta_solo_da_segni_simm,
            face = Faces.Surprised,
            composable = {
                Box(
                    modifier = Modifier.fillMaxWidth(),
                    contentAlignment = Alignment.Center
                ) {
                    MdCWord(
                        word = "X1:X2-N35:N35:N35",
                        rtl = false,
                        cart = false
                    )
                }
            }
        ),
        ExplanationContent(
            title = Res.string.exp_title_una_soluzione_utile,
            content = Res.string.exp_content_per_risolvere_l_ambiguit_possiamo_aggiungere_,
            face = Faces.Happy,
            composable = {
                Box(
                    modifier = Modifier.fillMaxWidth(),
                    contentAlignment = Alignment.Center
                ) {
                    MdCWord(
                        word = "X1:X2-N35:N35:N35-G43",
                        rtl = false,
                        cart = false
                    )
                }
            }
        ),
        ExplanationContent(
            title = Res.string.exp_title_nilo,
            content = Res.string.exp_content_miao,
            face = Faces.Idle,
            character = Characters.Nilo
        ),
        ExplanationContent(
            title = Res.string.exp_title_lezione_completata,
            content = Res.string.exp_content_ora_passiamo_al_quiz_per_mettere_alla_prova_q,
            face = Faces.Perfect
        )
    )
}

fun getFillerACapoComplementiQuizContent(): List<IQuizContent> {
    return listOf(
        TrueFalseContent(
            text = Res.string.quiz_a_capo_spezzare_parole,
            correct = true
        ),
        TrueFalseContent(
            text = Res.string.quiz_a_capo_trattino_obbligatorio,
            correct = false
        ),
        TrueFalseContent(
            text = Res.string.quiz_a_capo_segni_simmetrici,
            correct = true
        ),
        TrueFalseContent(
            text = Res.string.quiz_a_capo_quaglia_asimmetrica,
            correct = true
        ),
        TrueFalseContent(
            text = Res.string.quiz_a_capo_direzione_figure,
            correct = false
        )
    )
}
